<template>
  <v-dialog v-model="dialog" max-width="550" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        :small="!isMobile()"
        color="error"
        min-width="220"
        :block="isMobile()"
        v-on="on"
        v-bind="attrs"
        v-if="podeAlterarIncluir"
      >
        Cancelar plano</v-btn
      >
    </template>
    <v-card>
      <v-card-title class="green lighten-4 font-weight-bold"
        >Cancelar Plano</v-card-title
      >
      <v-card-text class="pt-5">
        <v-form ref="form">
          <v-textarea
            v-model="justificativa"
            rows="4"
            placeholder="Escreva o motivo para o qual você está solicitando o cancelamento do plano"
            :rules="[
              (v) =>
                v.length > 9 || 'Motivo deve conter no mínimo 10 caracteres',
            ]"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="error"
          rounded
          @click="solicitarCancelamentoPlano()"
          :loading="solicitandoCancelamento"
          >Solicitar cancelamento</v-btn
        >
        <v-btn text rounded @click="dialog = false">Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  watch: {
    dialog: function (open) {
      if (open) {
        this.justificativa = "";
      }
    },
  },
  computed: mapState("planoSaude", ["meuPlano","podeAlterarIncluir"]),
  data: () => ({
    dialog: false,
    justificativa: "",
    solicitandoCancelamento: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    async solicitarCancelamentoPlano() {
      if (this.$refs.form.validate()) {
        this.solicitandoCancelamento = true;
        await axios
          .post(
            "/colaborador/plano-saude/cancelar-plano",
            JSON.stringify({
              justificativa: this.justificativa,
            })
          )
          .then(async (res) => {
            if (res.data.success) {
              this.$router.go();
            } else this.$toasted.error(res.data.msg);
          })
          .catch((e) => this.$toasted.error(e));
        this.solicitandoCancelamento = false;
      }
    },
  },
};
</script>

<style>
</style>